export enum FeatureType {
  mutex0 = 'mutex0',
  mutex1 = 'mutex1',
  multi = 'multi',
}
